import {
  ACTION_PLANS_FULFILLED,
  ACTION_PLANS_PENDING,
  ACTION_PLANS_REJECTED,
  MY_ACTION_PLANS_FULFILLED,
  MY_ACTION_PLANS_PENDING,
  MY_ACTION_PLANS_REJECTED,
  MY_REPORTERS_ACTION_PLANS_FULFILLED,
  MY_REPORTERS_ACTION_PLANS_PENDING,
  MY_REPORTERS_ACTION_PLANS_REJECTED
} from "../constants";
import {
  IActionPlanPayload,
  IActionPlansState,
  IActiveActionPlanPayload,
  IMyReporterActionPlanPayload
} from "../../types";

type ActionPlansActions =
  | {
      type: typeof MY_ACTION_PLANS_PENDING;
    }
  | {
      type: typeof MY_ACTION_PLANS_FULFILLED;
      payload: IActiveActionPlanPayload;
    }
  | {
      type: typeof MY_ACTION_PLANS_REJECTED;
    }
  | {
      type: typeof MY_REPORTERS_ACTION_PLANS_PENDING;
    }
  | {
      type: typeof MY_REPORTERS_ACTION_PLANS_FULFILLED;
      payload: IMyReporterActionPlanPayload;
    }
  | {
      type: typeof MY_REPORTERS_ACTION_PLANS_REJECTED;
    }
  | {
      type: typeof ACTION_PLANS_PENDING;
    }
  | {
      type: typeof ACTION_PLANS_FULFILLED;
      payload: IActionPlanPayload;
    }
  | {
      type: typeof ACTION_PLANS_REJECTED;
    };
const initialState: IActionPlansState = {
  myActionPlans: {
    completed: false,
    activeItemPlans: [],
    historyItemPlans: {},
    pending: false,
    rejected: false
  },
  myDirectReportsActionPlans: {
    completed: false,
    activeActionPlans: [],
    historyActionPlans: [],
    pending: false,
    rejected: false
  },
  actionPlans: {
    completed: false,
    data: { employeeName: "", photo: "", actionPlans: [] },
    pending: false,
    rejected: false
  }
};

export default (state = initialState, action: ActionPlansActions) => {
  switch (action.type) {
    case MY_ACTION_PLANS_PENDING:
      return {
        ...state,
        myActionPlans: {
          ...state.myActionPlans,
          completed: false,
          activeItemPlans: initialState.myActionPlans.activeItemPlans,
          historyItemPlans: initialState.myActionPlans.historyItemPlans,
          pending: true
        }
      };
    case MY_ACTION_PLANS_FULFILLED: {
      const { data, active } = action.payload;
      if (active) {
        return {
          ...state,
          myActionPlans: {
            ...state.myActionPlans,
            completed: true,
            activeItemPlans: data.actionPlans,
            pending: false,
            rejected: false
          }
        };
      } else {
        return {
          ...state,
          myActionPlans: {
            ...state.myActionPlans,
            completed: true,
            historyItemPlans: data.sorted,
            pending: false,
            rejected: false
          }
        };
      }
    }
    case MY_ACTION_PLANS_REJECTED:
      return {
        ...state,
        myActionPlans: {
          completed: false,
          activeItemPlans: initialState.myActionPlans.activeItemPlans,
          historyItemPlans: initialState.myActionPlans.historyItemPlans,
          pending: false,
          rejected: true
        }
      };
    case MY_REPORTERS_ACTION_PLANS_PENDING:
      return {
        ...state,
        myDirectReportsActionPlans: {
          ...state.myDirectReportsActionPlans,
          completed: false,
          activeActionPlans: initialState.myDirectReportsActionPlans.activeActionPlans,
          historyActionPlans: initialState.myDirectReportsActionPlans.historyActionPlans,
          pending: true
        }
      };
    case MY_REPORTERS_ACTION_PLANS_FULFILLED: {
      const { data, active } = action.payload;
      if (active) {
        return {
          ...state,
          myDirectReportsActionPlans: {
            ...state.myDirectReportsActionPlans,
            completed: true,
            activeActionPlans: data.entities,
            pending: false,
            rejected: false
          }
        };
      } else {
        return {
          ...state,
          myDirectReportsActionPlans: {
            ...state.myDirectReportsActionPlans,
            completed: true,
            historyActionPlans: data.entities,
            pending: false,
            rejected: false
          }
        };
      }
    }
    case MY_REPORTERS_ACTION_PLANS_REJECTED:
      return {
        ...state,
        myDirectReportsActionPlans: {
          completed: false,
          activeActionPlans: initialState.myDirectReportsActionPlans.activeActionPlans,
          historyActionPlans: initialState.myDirectReportsActionPlans.historyActionPlans,
          pending: false,
          rejected: true
        }
      };
    case ACTION_PLANS_PENDING:
      return {
        ...state,
        actionPlans: {
          ...state.actionPlans,
          completed: false,
          data: initialState.actionPlans.data,
          pending: true
        }
      };
    case ACTION_PLANS_FULFILLED: {
      return {
        ...state,
        actionPlans: {
          ...state.actionPlans,
          completed: true,
          data: action.payload,
          pending: false,
          rejected: false
        }
      };
    }
    case ACTION_PLANS_REJECTED:
      return {
        ...state,
        actionPlans: {
          completed: false,
          data: initialState.actionPlans.data,
          pending: false,
          rejected: true
        }
      };
    default:
      return state;
  }
};
